// extracted by mini-css-extract-plugin
export default {"SemanticModal":"q7lMPL"};